var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ee44529a8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.1875 153.492188 L 348.1875 153.492188 L 348.1875 374.714844 L 27.1875 374.714844 Z M 27.1875 153.492188 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 99.5625 153.894531 L 99.5625 112.003906 C 99.5625 63.472656 139.09375 23.984375 187.6875 23.984375 C 236.28125 23.984375 275.8125 63.472656 275.8125 112.003906 L 275.8125 153.894531 L 299.566406 153.894531 L 299.566406 112.003906 C 299.566406 50.289062 249.476562 0.257812 187.6875 0.257812 C 125.898438 0.257812 75.808594 50.289062 75.808594 112.003906 L 75.808594 153.894531 L 99.5625 153.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee44529a8b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 207.921875 313.253906 L 167.453125 313.253906 C 166.523438 313.253906 165.84375 312.363281 166.09375 311.464844 L 169.167969 300.386719 L 176.640625 273.460938 L 179.574219 262.902344 C 170.035156 259.554688 163.1875 250.5 163.1875 239.828125 C 163.1875 226.308594 174.152344 215.351562 187.6875 215.351562 C 201.222656 215.351562 212.1875 226.308594 212.1875 239.828125 C 212.1875 250.5 205.339844 259.550781 195.800781 262.902344 L 198.726562 273.460938 L 206.207031 300.386719 L 209.28125 311.464844 C 209.53125 312.363281 208.851562 313.253906 207.921875 313.253906 Z M 335.292969 153.894531 L 40.082031 153.894531 C 32.960938 153.894531 27.1875 159.65625 27.1875 166.773438 L 27.1875 361.832031 C 27.1875 368.945312 32.960938 374.714844 40.082031 374.714844 L 335.292969 374.714844 C 342.414062 374.714844 348.1875 368.945312 348.1875 361.832031 L 348.1875 166.773438 C 348.1875 159.65625 342.414062 153.894531 335.292969 153.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bd8a51b00f388c65c3e2191d4c431d0c.svg";
export { ForwardRef as ReactComponent };